import { gql } from "@apollo/client";

const LOGOUT_QUERY = gql`
  mutation logout {
    logout {
      status
      message
    }
  }
`;

const FIREBASE_LOGIN_QUERY = gql`
  mutation ($input: WebsiteLoginInput) {
    firebaseLogin(input: $input) {
      refresh_token
      access_token
      expires_in
      token_type
      user {
        id
        email
        phone
        arranger {
          id
          prefix
          first_name
          last_name
          partnerships {
            id
            class_type_id
            show_dual_pricing
          }
          roles {
            id
            name
            permissions {
              id
              name
            }
          }
          company {
            id
            class_type {
              id
              name
            }
          }
          arranger_phones {
            id
            phone_prefix
            phone
            is_verified
            is_primary
          }
          arranger_emails {
            id
            email
            is_verified
            is_primary
          }
          nationality {
            id
            name
          }
          dob
          passport
          passport_exp
          nrc
          address
          township {
            id
            name
            city {
              id
              name
              region {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
const FIREBASE_SIGNUP_QUERY = gql`
  mutation firebaseSignup($input: RegisterInput) {
    firebaseSignup(input: $input) {
      tokens {
        access_token
        refresh_token
        expires_in
        token_type
        user {
          id
          email
        }
      }
      status
    }
  }
`;

const FIREBASE_LOGIN_BY_TOKEN_QUERY = gql`
  mutation ($input: FirebaseLoginInput) {
    firebaseLoginByToken(input: $input) {
      refresh_token
      access_token
      id_token
      expires_in
      token_type
      user {
        id
        email
        phone
        arranger {
          id
          prefix
          first_name
          last_name
          partnerships {
            id
            class_type_id
            show_dual_pricing
          }
          company {
            id
            name
            arrangers {
              id
              prefix
              first_name
              last_name
              arranger_phones {
                id
                phone_prefix
                phone
                is_verified
                is_primary
              }
              arranger_emails {
                id
                email
                is_verified
                is_primary
              }
              nationality {
                id
                name
              }
              dob
              passport
              passport_exp
              nrc
              address
              township {
                id
                name
                city {
                  id
                  name
                  region {
                    id
                    name
                  }
                }
              }
            }
          }
          roles {
            id
            name
            permissions {
              id
              name
            }
          }
          arranger_phones {
            id
            phone_prefix
            phone
            is_verified
            is_primary
          }
          arranger_emails {
            id
            email
            is_verified
            is_primary
          }
          nationality {
            id
            name
          }
          dob
          passport
          passport_exp
          nrc
          address
          township {
            id
            name
            city {
              id
              name
              region {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

const RESET_PASSWORD = gql`
  mutation ($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      status
      message
    }
  }
`;

const UPDATE_PASSWORD = gql`
  mutation ($input: NewPasswordWithCodeInput) {
    updateForgottenPassword(input: $input) {
      status
      message
    }
  }
`;

const VERIFY_EMAIL = gql`
  mutation verifyEmail($input: VerifyEmailInput!) {
    verifyEmail(input: $input) {
      refresh_token
      access_token
      expires_in
      token_type
      user {
        id
        email
        arranger {
          id
          prefix
          first_name
          last_name
          partnerships {
            id
            class_type_id
            show_dual_pricing
          }
          login_types {
            id
            name
          }
          arranger_phones {
            id
            phone_prefix
            phone
            is_verified
            is_primary
          }
          arranger_emails {
            id
            email
            is_verified
            is_primary
          }
          company {
            id
            name
            active
            class_type {
              id
              name
            }
            arrangers {
              id
              prefix
              first_name
              last_name
              arranger_phones {
                id
                phone_prefix
                phone
                is_verified
                is_primary
              }
              arranger_emails {
                id
                email
                is_verified
                is_primary
              }
              nationality {
                id
                name
              }
              dob
              passport
              passport_exp
              nrc
              address
              township {
                id
                name
                city {
                  id
                  name
                  region {
                    id
                    name
                  }
                }
              }
            }
          }
          nationality {
            id
            name
          }
          dob
          passport
          passport_exp
          nrc
          address
          roles {
            id
            name
            permissions {
              id
              name
            }
          }
        }
      }
    }
  }
`;
const VERIFY_EMAIL_EMPLOYEE = gql`
  mutation verifyEmail($input: VerifyEmailInput!) {
    verifyEmail(input: $input) {
      refresh_token
      access_token
      expires_in
      token_type
      user {
        id
        email
        login_types {
          id
          name
        }
        roles {
          id
          name
          permissions {
            id
            name
          }
        }
        arranger {
          id
          prefix
          first_name
          last_name
          arranger_phones {
            id
            phone_prefix
            phone
            is_verified
            is_primary
          }
          arranger_emails {
            id
            email
            is_verified
            is_primary
          }
          company {
            id
            name
            active
            class_type {
              id
              name
            }
            arrangers {
              id
              prefix
              first_name
              last_name
              arranger_phones {
                id
                phone_prefix
                phone
                is_verified
                is_primary
              }
              arranger_emails {
                id
                email
                is_verified
                is_primary
              }
              nationality {
                id
                name
              }
              dob
              passport
              passport_exp
              nrc
              address
              township {
                id
                name
                city {
                  id
                  name
                  region {
                    id
                    name
                  }
                }
              }
            }
          }
          nationality {
            id
            name
          }
          dob
          passport
          passport_exp
          nrc
          address
        }
      }
    }
  }
`;

const SEND_EMAIL_OTP = gql`
  mutation ($input: SendEmailLinkAuthInput) {
    sendEmailLinkAuth(input: $input) {
      status
      message
    }
  }
`;

const GET_LANGUAGES = gql`
  query ($filter: [filterInput], $first: Int!, $page: Int) {
    languagesForFe(
      filter: $filter
      first: $first
      page: $page
      orderBy: [{ column: "id", order: DESC }]
    ) {
      data {
        id
        code
        name
        show_flag
        updated_at
      }
      paginatorInfo {
        count
        currentPage
        perPage
      }
    }
  }
`;

const AGENT_LOGIN_QUERY = gql`
  mutation ($input: WebsiteLoginInput) {
    agentLogin(input: $input) {
      refresh_token
      access_token
      token_type
      expires_in
      user {
        id
        name
        email
        arranger {
          id
          prefix
          first_name
          last_name
          login_types {
            id
            name
          }
          roles {
            id
            name
            permissions {
              id
              name
            }
          }
          company {
            id
            name
            class_type {
              id
              name
            }
          }
          arranger_phones {
            id
            phone
            phone_prefix
            is_verified
            is_primary
          }
          arranger_emails {
            id
            email
            is_verified
            is_primary
          }
          nationality {
            id
            name
          }
          dob
          passport
          passport_exp
          nrc
          address
        }
      }
    }
  }
`;

const EMPLOYEE_LOGIN_QUERY = gql`
  mutation ($input: WebsiteLoginInput) {
    employeeLogin(input: $input) {
      refresh_token
      access_token
      token_type
      expires_in
      user {
        id
        name
        email
        login_types {
          id
          name
        }
        company {
          id
          name
          arrangers {
            id
            prefix
            first_name
            last_name
            nationality {
              id
              name
            }
            dob
            passport
            passport_exp
            nrc
            address
            township {
              id
              name
              city {
                id
                name
                region {
                  id
                  name
                }
              }
            }
          }
        }
        roles {
          id
          name
          permissions {
            id
            name
          }
        }
        arranger {
          id
          prefix
          first_name
          last_name
          arranger_phones {
            id
            phone
            phone_prefix
            is_verified
            is_primary
          }
          arranger_emails {
            id
            email
            is_verified
            is_primary
          }
          nationality {
            id
            name
          }
          dob
          passport
          passport_exp
          nrc
          address
          township {
            id
            name
            city {
              id
              name
              region {
                id
                name
              }
            }
          }
          company {
            id
            name
            class_type {
              id
              name
            }
          }
        }
      }
    }
  }
`;

const FETCH_ZADA_CREDENTIAL = gql`
  mutation ($input: fetchZadaCredentialInput) {
    fetchZadaCredential(input: $input) {
      attributes
      status
    }
  }
`;

const ZADA_LOGIN = gql`
  mutation ($input: zadaLoginInput) {
    zadaLogin(input: $input) {
      access_token
      refresh_token
      expires_in
      token_type
      id_token
      zada_id
      user {
        id
        email
        phone
        arranger {
          id
          prefix
          first_name
          last_name
          company {
            id
            name
            arrangers {
              id
              prefix
              first_name
              last_name
              arranger_phones {
                id
                phone_prefix
                phone
                is_verified
                is_primary
              }
              arranger_emails {
                id
                email
                is_verified
                is_primary
              }
              nationality {
                id
                name
              }
              dob
              passport
              passport_exp
              nrc
              address
              township {
                id
                name
                city {
                  id
                  name
                  region {
                    id
                    name
                  }
                }
              }
            }
          }
          roles {
            id
            name
            permissions {
              id
              name
            }
          }
          arranger_phones {
            id
            phone_prefix
            phone
            is_verified
            is_primary
          }
          arranger_emails {
            id
            email
            is_verified
            is_primary
          }
          nationality {
            id
            name
          }
          dob
          passport
          passport_exp
          nrc
          address
          township {
            id
            name
            city {
              id
              name
              region {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

const CREATE_ARR_ZADA_WALLET = gql`
  mutation ($input: createArrangerZadaWalletInput) {
    createArrangerZadaWallet(input: $input) {
      id
      arranger {
        id
      }
      zada_id
      phone_prefix
      phone
      name
      zada_connection_id
      created_at
      updated_at
      deleted_at
    }
  }
`;

const SEND_LOGIN_PHONE_OTP = gql`
  mutation ($input: SendLoginPhoneOtpInput!) {
    sendLoginPhoneOtp(input: $input) {
      success
      message
      phone
    }
  }
`;

const VERIFY_LOGIN_PHONE_OTP = gql`
  mutation ($input: VerifyLoginPhoneOtpInput!) {
    verifyLoginPhoneOtp(input: $input) {
      success
      message
      refresh_token
      access_token
      expires_in
      token_type
      user {
        id
        email
        phone
        arranger {
          id
          prefix
          first_name
          last_name
          partnerships {
            id
            class_type_id
            show_dual_pricing
          }
          company {
            id
            name
            arrangers {
              id
              prefix
              first_name
              last_name
              arranger_phones {
                id
                phone_prefix
                phone
                is_verified
                is_primary
              }
              arranger_emails {
                id
                email
                is_verified
                is_primary
              }
              nationality {
                id
                name
              }
              dob
              passport
              passport_exp
              nrc
              address
              township {
                id
                name
                city {
                  id
                  name
                  region {
                    id
                    name
                  }
                }
              }
            }
          }
          roles {
            id
            name
            permissions {
              id
              name
            }
          }
          arranger_phones {
            id
            phone_prefix
            phone
            is_verified
            is_primary
          }
          arranger_emails {
            id
            email
            is_verified
            is_primary
          }
          nationality {
            id
            name
          }
          dob
          passport
          passport_exp
          nrc
          address
          township {
            id
            name
            city {
              id
              name
              region {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

const GET_LOGIN_PEOPLE_DETAILS = gql`
  query loginPeopleDetails {
    loginPeopleDetails {
      id
      partnerships {
        id
        name
        show_dual_pricing
        class_type_id
      }
    }
  }
`;

const SEND_LOGIN_EMAIL_OTP = gql`
  mutation SendLoginEmailOtp($input: SendLoginEmailOtpInput!) {
    sendLoginEmailOtp(input: $input) {
      success
      message
      email
      is_verified
    }
  }
`;
const VERIFY_LOGIN_EMAIL_OTP = gql`
  mutation VerifyLoginEmailOtp($input: VerifyLoginEmailOtpInput!) {
    verifyLoginEmailOtp(input: $input) {
      success
      message
      access_token
      refresh_token
      expires_in
      token_type
      id_token
      user {
        id
        email
        is_verified
        is_primary
        arranger {
          id
          prefix
          first_name
          last_name
          roles {
            id
            name
          }
        }
      }
    }
  }
`;

export {
  LOGOUT_QUERY,
  FIREBASE_LOGIN_QUERY,
  FIREBASE_SIGNUP_QUERY,
  FIREBASE_LOGIN_BY_TOKEN_QUERY,
  RESET_PASSWORD,
  UPDATE_PASSWORD,
  VERIFY_EMAIL,
  VERIFY_EMAIL_EMPLOYEE,
  SEND_EMAIL_OTP,
  GET_LANGUAGES,
  AGENT_LOGIN_QUERY,
  FETCH_ZADA_CREDENTIAL,
  ZADA_LOGIN,
  CREATE_ARR_ZADA_WALLET,
  EMPLOYEE_LOGIN_QUERY,
  SEND_LOGIN_PHONE_OTP,
  VERIFY_LOGIN_PHONE_OTP,
  GET_LOGIN_PEOPLE_DETAILS,
  SEND_LOGIN_EMAIL_OTP,
  VERIFY_LOGIN_EMAIL_OTP,
};
